import styled from 'styled-components';
import { Box, Image, Text } from '@chakra-ui/react';
import { ScreenContext } from './ScreenProvider';
import { useContext } from 'react';
import { convertFontSize } from './Util';
import { IHeaderMenu } from './Interfaces';

const Banner = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 36.5vw;
  height: 36.5vw;
  max-height: 36.5vw;

  @media (max-width: 1024px) {
    min-height: 350px;
    height: 48vw;
    max-height: 48vw;
  }

  @media (max-width: 768px) {
    min-height: 100vw;
    height: 100%;
    max-height: 768px;
  }
`;

interface IContentBanner {
  data: IHeaderMenu;
  isShown?: boolean;
  color?: string;
}

const ContentBanner: React.FC<IContentBanner> = ({
  data,
  isShown = true,
  color = "#ffffff",
}) => {
  const screen = useContext(ScreenContext).style;

  return (
    <Banner id={"content-banner"}>
      <Image src={data.bg[screen]} w="100%" h="100%" alt="" />
      {isShown &&
        <Box position={"absolute"} left={0} top={0} w={"100%"} h={"100%"} display={"flex"} flexDir={"column"} justifyContent={"center"} alignItems={"center"}>
          <Text fontSize={convertFontSize(30, 50, "pc")} color={color} fontWeight={600}>
            {data.desc.title ?? data.name}
          </Text>
          {data.desc.desc && data.desc.desc !== "" &&
            <Text mt={"20px"} whiteSpace={"pre-wrap"} textAlign={"center"}>
              {screen === "pc" ? data.desc.desc : data.desc.sub}
            </Text>
          }
        </Box>
      }
    </Banner>
  );
};

export default ContentBanner;